module.exports = "/shared/img/coins.png";


//////////////////
// WEBPACK FOOTER
// ./src/ui/img/coins.png
// module id = 435
// module chunks = 13